var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReopenReportIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.7998 3.07056C9.1101 1.18585 5.33539 0.331755 2.52582 0.0142756C1.13532 -0.142849 0 1.0183 0 2.45091V16.7177C0 18.1503 1.13532 19.3119 2.52582 19.469C5.33539 19.7865 9.1101 20.6406 11.7998 22.5253C12.0582 22.7064 12.3616 22.797 12.665 22.797V3.34223C12.3616 3.34223 12.0582 3.25167 11.7998 3.07056Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85996 6.50776C2.94025 5.98934 3.42559 5.63416 3.94402 5.71445C5.59398 5.96998 7.45213 6.39708 9.20724 7.07579C9.69653 7.265 9.93979 7.81503 9.75058 8.30432C9.56137 8.79362 9.01134 9.03688 8.52205 8.84767C6.92797 8.23124 5.20952 7.83283 3.65327 7.59182C3.13485 7.51153 2.77967 7.02618 2.85996 6.50776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85996 11.5859C2.94025 11.0675 3.42559 10.7123 3.94402 10.7926C4.77957 10.922 5.66605 11.095 6.56401 11.3216C7.07267 11.4499 7.38099 11.9663 7.25266 12.4749C7.12432 12.9836 6.60794 13.2919 6.09927 13.1636C5.26542 12.9532 4.43754 12.7914 3.65327 12.6699C3.13485 12.5897 2.77967 12.1043 2.85996 11.5859Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5303 3.07056C16.2199 1.18585 19.9946 0.331755 22.8042 0.0142756C24.1947 -0.142849 25.33 1.0183 25.33 2.45091V16.7177C25.33 18.1503 24.1947 19.3119 22.8042 19.469C19.9946 19.7865 16.2199 20.6406 13.5303 22.5253C13.2718 22.7064 12.9684 22.797 12.665 22.797V3.34223C12.9684 3.34223 13.2718 3.25167 13.5303 3.07056Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReopenReportIconDark);
export default __webpack_public_path__ + "static/media/reopen-report-icon-dark.207210d7.svg";
export { ForwardRef as ReactComponent };